import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute } from '../../../../actions/Buy'
import {
  infocertCheckBoxCertificato,
  postInfocertCertificato,
} from '../../../../actions/buy/Findomestic'
import { postInfocertCertificatoV2 } from '../../../../actions/buy/FindomesticFirmaV2'
import {
  getFinanziamentoAssicurato,
  getFinanziamentoNonAssicurato,
  validaCheckBoxes,
} from '../../../../utils/firmaUtils'
import OrderRecoveryBanner from '../../../dumb/OrderRecoveryBanner'
import BuyButton from '../../dumb/BuyButton'
import BuyMiniCart from '../../dumb/BuyMiniCart'
import CheckBoxes from '../../dumb/FindomesticFirmaDigitale/CheckBoxes'
import Links from '../../dumb/FindomesticFirmaDigitale/Links'
import { preparaValoriLogistica } from '../../utils'

class FindomesticCertificatoInforcert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkBoxErrors: {},
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 110 })
  }

  handleSubmit() {
    const t = this

    return () => {
      if (
        validaCheckBoxes(
          this.props.findomestic.certificatoCheckBoxes,
          t.state.checkBoxErrors,
          checkBoxErrors => t.setState(checkBoxErrors)
        )
      ) {
        if (!t.props.isV2) {
          t.props
            .postInfocertCertificato()
            .then(() => t.props.reroute('/crea-pin'))
        } else {
          t.props
            .postInfocertCertificatoV2()
            .then(() => t.props.reroute('/v2/contratto-infocert'))
        }
      }
    }
  }

  render() {
    const { product } = this.props
    const valoriLogistica = preparaValoriLogistica(
      this.props.pricing.total,
      this.props.logistica
    )
    const h1 = 'Firma Digitale: sottoscrivi i documenti e concludi la richiesta'
    return (
      <div className="sellout-findomestic FindomesticInfocertFirma">
        <section
          className="relative process"
          id={'FindomesticCertificatoInforcert'}
        >
          <div className="process__header">
            <h1 className="process__title">{h1}</h1>
          </div>
          <div className={'messages warning'}>
            <div className={'container'}>
              <OrderRecoveryBanner />
            </div>
          </div>
          <div className="user-informations">
            <div className="container_small">
              <div className="process__column process__column__left">
                <h1>
                  <span aria-hidden="true" className="icon-check verde"></span>I
                  tuoi dati sono stati inviati a Findomestic
                </h1>
                <p>
                  <b>
                    Adesso puoi procedere con la firma digitale dei documenti
                    per terminare la tua richiesta di finanziamento.
                  </b>
                </p>
                <p>
                  La Firma Digitale &egrave; la soluzione facile, sicura e
                  gratuita per sottoscrivere online il tuo contratto di
                  finanziamento. D'ora in poi potrai recuperare la tua richiesta
                  in qualsiasi momento seguendo le istruzioni che con
                  Findomestic ti invieremo tramite email.
                </p>
                <hr />
                <b>Attiva il certificato InfoCert</b>
                <p>
                  {this.props.findomestic.certificatoInfocertStepAbstract ||
                    `Il certificato &egrave; il documento necessario per poter
                  firmare digitalmente. Ti invitiamo a scaricare i moduli e
                  prendere visione delle condizioni generali di utilizzo dei
                  certificati digitali.`}
                </p>
                <Links links={this.props.findomestic.certificatoLinks} />
                <hr />
                <b>
                  {!this.props.isV2
                    ? 'Il sottoscritto:'
                    : 'Cliccando sul tasto "Prosegui":'}
                </b>
                <CheckBoxes
                  checkBoxErrors={this.state.checkBoxErrors}
                  checkBoxOnChangeAction={
                    this.props.infocertCheckBoxCertificato
                  }
                  checkBoxes={this.props.findomestic.certificatoCheckBoxes}
                />
                <div className={'buttons_set center no-brd more-pd'}>
                  <BuyButton
                    classes={`btn btn-primary ${
                      this.props.fetching ? ' btn-disabled' : ''
                    }`}
                    label={'Prosegui'}
                    update={this.handleSubmit()}
                  />
                </div>
              </div>
              <div className="process__column process__column__right">
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={getFinanziamentoAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  finanziamentoNonAssicurato={getFinanziamentoNonAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={this.props.paymentMethod}
                  price={product.prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  serviziAssicurativiSelezionati={
                    this.props.findomestic.servizi_assicurativi_selezionati
                  }
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

FindomesticCertificatoInforcert.defaultProps = {
  isV2: false,
}

FindomesticCertificatoInforcert.propTypes = {
  product: PropTypes.object,
  ordine: PropTypes.object,
  pricing: PropTypes.object,
  logistica: PropTypes.object,
  fetching: PropTypes.bool,
  customer: PropTypes.object,
  findomestic: PropTypes.object,
  paymentMethod: PropTypes.string,
  reroute: PropTypes.func,
  phaseChange: PropTypes.func,
  postInfocertCertificato: PropTypes.func,
  postInfocertCertificatoV2: PropTypes.func,
  infocertCheckBoxCertificato: PropTypes.func,
  financements: PropTypes.object,
  isV2: PropTypes.bool,
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  product: state.product,
  ordine: state.ordine,
  findomestic: state.findomestic,
  logistica: state.logistica,
  customer: state.customer,
  fetching: state.ui.fetching,
  paymentMethod: state.payment.method,
  financements: state.financements,
})

const mapDispatchToProps = dispatch => ({
  reroute: payload => dispatch(reroute(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  infocertCheckBoxCertificato: payload =>
    dispatch(infocertCheckBoxCertificato(payload)),
  postInfocertCertificato: () => dispatch(postInfocertCertificato),
  postInfocertCertificatoV2: () => dispatch(postInfocertCertificatoV2),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindomesticCertificatoInforcert)
